import { z } from 'zod';

export const protocolSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
});

export type ProtocolFormValues = z.infer<typeof protocolSchema>;
